/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artcraft_V_DeveloperInputs */

const en_home_artcraft_v_developer = /** @type {(inputs: Home_Artcraft_V_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft team`)
};

/**
* | output |
* | --- |
* | "ArtCraft team" |
*
* @param {Home_Artcraft_V_DeveloperInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_artcraft_v_developer = /** @type {((inputs?: Home_Artcraft_V_DeveloperInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artcraft_V_DeveloperInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_artcraft_v_developer(inputs)
});
export { home_artcraft_v_developer as "home.artcraft.v_developer" }